/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import React, { useContext, useState, useEffect } from 'react'
import { Map, Header, Loading, Snackbar } from '../components/index'
import { Col, Row } from 'react-bootstrap'
import { WebApi } from '../api/web'
import { Context } from '../context/context'
import { Errors } from '../utilities/error'
import Carousel from 'react-elastic-carousel'
import { BiSearchAlt } from 'react-icons/bi'
import { FiMapPin } from 'react-icons/fi'
import { AiOutlineClose } from 'react-icons/ai'
import 'styled-components'
import ClipLoader from 'react-spinners/ClipLoader'

const Landing = () => {
  const breactPoint = [
    { width: 0, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 992, itemsToShow: 6 },
  ]
  const [range, setRange] = useState(5000)
  const [currentRange, setCurrentRange] = useState(0)
  const [typingTimeout, setTypingTimeout] = useState(0)
  const [lawyers, setLawyers] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingAddres, setLoadingAddress] = useState(false)
  const [addressList, setAddressList] = useState([])
  const [layer, setLayer] = useState(true)
  const [addressCordinate, setAddressCordinate] = useState(null)
  const [typesWork, setTypesWork] = useState([])
  const [searchTypesWork, setSearchTypesWork] = useState(false)
  const [changeView, setChangeView] = useState(true)
  const [valueSearch, setValueSearch] = useState(null)
  const [chooseTypesWork, setChooseTypesWork] = useState([])
  const [location, setLocation] = useState(null)

  const AppContext = useContext(Context)

  useEffect(() => {
    SearchLawyers()
  }, [chooseTypesWork, range, AppContext.GPS])

  useEffect(() => {
    TypeWork()
  }, [])

  const searchAddress = async (value) => {
    setLoadingAddress(true)
    await WebApi.searchAddress(value)
      .then((res) => {
        setLoadingAddress(false)
        setAddressList(res.data.data.addressSearch)
      })
      .catch((err) => {
        setLoadingAddress(false)
        Snackbar({
          title: 'نا موفق',
          message: Errors[err.response.data.errors[0].message],
          type: 'warning',
        })
      })
  }
  const searchMap = (value) => {
    setChangeView(false)
    setValueSearch(value)
    if (typingTimeout) {
      clearTimeout(typingTimeout)
      setTypingTimeout(0)
    }
    setTypingTimeout(
      setTimeout(() => {
        searchAddress(value)
        setChangeView(true)
        setLayer(true)
      }, 2000)
    )
  }

  const rangeMap = (value) => {
    setCurrentRange(value)
    if (typingTimeout) {
      clearTimeout(typingTimeout)
      setTypingTimeout(0)
    }
    setTypingTimeout(
      setTimeout(() => {
        if (AppContext.GPS) {
          setRange(value)
        } else {
          Snackbar({
            title: 'هشدار',
            message: 'کاربر گرامی ابتدا موقعیت خود را روی نقشه مشخص کنید',
            type: 'warning',
          })
        }
      }, 2000)
    )
  }
  const SearchLawyers = async () => {
    setLoading(true)
    await WebApi.searchLawyers(chooseTypesWork, AppContext.GPS, range)
      .then((res) => {
        setLoading(false)
        setLawyers(res.data.data.searchLawyers.lawyers)
        if (AppContext.GPS && res.data.data.searchLawyers.lawyers.length == 0) {
          Snackbar({
            message: 'هیچ وکیلی در نزدیکی شما وجود ندارد',
            type: 'warning',
          })
        }
      })
      .catch((err) => {
        setLoading(false)
        Snackbar({
          message: err.response.data.errors[0].message,
          type: 'warning',
        })
      })
  }

  const TypeWork = async () => {
    setLoading(true)
    await WebApi.typeWork()
      .then((res) => {
        setTypesWork(res.data.data.servicesOnMap)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  const ChoooseTypeWork = (id) => {
    setSearchTypesWork(true)
    setAddressCordinate(null)
    if (chooseTypesWork[0] == id) {
      setChooseTypesWork([])
    } else {
      setChooseTypesWork([id])
    }
  }
  const settingLayer = () => {
    setAddressList([])
    setLayer(false)
  }
  const settingAddress = (data) => {
    AppContext.setGPS(data)
    setAddressCordinate(data)
    setLayer(false)
  }
  const settingInputValue = () => {
    setValueSearch(null)
    setAddressCordinate(null)
    setLayer(false)
    AppContext.setGPS(null)
  }
  return (
    <div className='landing'>
      {loading && <Loading />}
      <div>
        <div className='map-page'>
          <Header title={'دکتر وکیل'} />
          <Map
            {...{
              lawyers,
              addressCordinate,
              searchTypesWork,
              changeView,
              chooseTypesWork,
              typesWork,
            }}
          />

          <div className='search-tools'>
            <Row className='mb-2'>
              <Col xl={6}>
                <div className='range-slider-input'>
                  <div>
                    <span className='d-sm-none'>مسافت</span>
                    <span className='d-none d-sm-block'>میزان مسافت</span>
                  </div>
                  <div className='inner-range-slider-input'>
                    <span>از صفر</span>
                    <input
                      type='range'
                      value={currentRange}
                      min='0'
                      max='5000'
                      step='1'
                      id='customRange3'
                      onChange={(e) => rangeMap(e.target.value)}
                    />
                    <span>تا {currentRange} متر</span>
                  </div>
                </div>
              </Col>
              <Col xl={6}>
                <div className='addressList-search'>
                  <div className='search-box-2'>
                    <div
                      onClick={() => settingLayer()}
                      className={`layer-addressList ${
                        layer && valueSearch && valueSearch.length > 3
                          ? 'active'
                          : 'inactive'
                      }`}
                    ></div>
                    <div
                      className={`addressList scrollbar-section ${
                        layer && valueSearch && valueSearch.length > 3
                          ? 'active'
                          : 'inactive'
                      }`}
                    >
                      {!loadingAddres ? (
                        addressList.length > 0 ? (
                          addressList.map((address, index) => (
                            <div className='item' key={index}>
                              <span
                                onClick={() =>
                                  settingAddress(address.coordinates)
                                }
                              >
                                <FiMapPin />
                                <span className='pr-2 pt-2'>
                                  {address.address}
                                </span>
                              </span>
                              <span>
                                <BiSearchAlt />
                              </span>
                            </div>
                          ))
                        ) : (
                          <div className='text-center'>
                            <h6>آدرسی پیدا نشد</h6>
                          </div>
                        )
                      ) : (
                        <div className='d-flex justify-content-center align-items-center'>
                          <ClipLoader
                            loading={!loadingAddres}
                            size={40}
                            color='#fff'
                          />
                        </div>
                      )}
                    </div>
                    <div className='inner-search-address'>
                      {(valueSearch || AppContext.GPS) && (
                        <span
                          onClick={() => settingInputValue()}
                          className='icon'
                          size={25}
                        >
                          <AiOutlineClose />
                        </span>
                      )}

                      <input
                        type='text'
                        placeholder='آدرس منطقه یا محل...'
                        onChange={(e) => searchMap(e.target.value)}
                        value={valueSearch ? valueSearch : ''}
                      />
                    </div>
                    <div>
                      <BiSearchAlt size={25} color={'#fff'} />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <div className='type-search'>
              <Carousel breakPoints={breactPoint} isRTL={true}>
                {typesWork.map((typeWork, index) => (
                  <span
                    onClick={() => ChoooseTypeWork(typeWork._id)}
                    className={`${
                      chooseTypesWork[0] == typeWork._id ? 'active' : ''
                    }`}
                    key={index}
                  >
                    {typeWork.title}
                  </span>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Landing
